import {
  AUTOMATION_CONFIG_LINK_IDS,
  AUTOMATION_CONFIG_QUESTIONNAIRE_ID,
  AUTOMATION_ID_TO_TYPE_CODE,
  TYPE_CODE_TO_AUTOMATION_ID,
} from "../constants/automationFhirConstants";
import type { AutomationConfig, AutomationId } from "../types";

function findItemByLinkId(
  resource: fhir5.QuestionnaireResponse,
  linkId: string,
): fhir5.QuestionnaireResponseItem | undefined {
  return resource.item?.find((item) => item.linkId === linkId);
}

function getFirstAnswer(
  item: fhir5.QuestionnaireResponseItem | undefined,
): fhir5.QuestionnaireResponseItemAnswer | undefined {
  if (!item?.answer?.length) return undefined;
  return item.answer[0];
}

export function getAutomationIdFromQuestionnaireResponse(
  resource: fhir5.QuestionnaireResponse,
): AutomationId | undefined {
  const automationTypeAnswer = getFirstAnswer(
    findItemByLinkId(resource, AUTOMATION_CONFIG_LINK_IDS.automationType),
  );
  const automationTypeCode = automationTypeAnswer?.valueCoding?.code;
  return automationTypeCode ? TYPE_CODE_TO_AUTOMATION_ID[automationTypeCode] : undefined;
}

export function toAutomationConfigFromQuestionnaireResponse(
  resource: fhir5.QuestionnaireResponse,
): AutomationConfig | null {
  if (resource.questionnaire !== AUTOMATION_CONFIG_QUESTIONNAIRE_ID) return null;

  const automationId = getAutomationIdFromQuestionnaireResponse(resource);
  if (!automationId) return null;

  const messageTemplateId = getFirstAnswer(
    findItemByLinkId(resource, AUTOMATION_CONFIG_LINK_IDS.messageTemplateId),
  )?.valueString;

  // Config legada pode conter questionnaireId — ignoramos na leitura.
  if (!messageTemplateId) {
    return null;
  }

  return {
    automationId,
    messageTemplateId,
  };
}

export function toQuestionnaireResponseFromAutomationConfig(input: {
  config: AutomationConfig;
  authorReference: string;
  sourceReference: string;
  existingId?: string;
}): fhir5.QuestionnaireResponse {
  const { config, authorReference, sourceReference, existingId } = input;

  const items: fhir5.QuestionnaireResponseItem[] = [
    {
      linkId: AUTOMATION_CONFIG_LINK_IDS.automationType,
      text: "Tipo de Automação",
      answer: [{ valueCoding: { code: AUTOMATION_ID_TO_TYPE_CODE[config.automationId] } }],
    },
    {
      linkId: AUTOMATION_CONFIG_LINK_IDS.messageTemplateId,
      text: "Template de mensagem (ID interno)",
      answer: [{ valueString: config.messageTemplateId }],
    },
  ];

  const resource: fhir5.QuestionnaireResponse = {
    resourceType: "QuestionnaireResponse",
    questionnaire: AUTOMATION_CONFIG_QUESTIONNAIRE_ID,
    status: "in-progress",
    author: { reference: authorReference },
    source: { reference: sourceReference },
    item: items,
  };

  if (existingId) resource.id = existingId;
  return resource;
}
